import { useMemo } from "react";
import { useData } from "@/context/DataContext";
import { iso, monthKey, sumA } from "@/lib/money";

export function useStats() {
  const { db, period, anchor, mode } = useData();
  return useMemo(() => {
    const [s, e] = period;
    const a = iso(s), z = iso(e);
    const ex = db.expenses;
    const m = ex.filter((i) => i.date >= a && i.date < z);
    const total = sumA(m);
    const y = anchor.getFullYear();
    const ytd = sumA(ex, (i) => i.date.startsWith(String(y)));
    const inP = sumA(db.incomes, (i) => i.date >= a && i.date < z);
    const inA = sumA(db.incomes, (i) => i.date < z);
    const spA = sumA(ex, (i) => i.date < z);
    const svA = sumA(db.savings, (i) => i.date < z);
    const svP = sumA(db.savings, (i) => i.date >= a && i.date < z);
    const mk = monthKey(anchor);
    const monthSpend = {};
    let monthTotal = 0;
    ex.forEach((i) => { if (i.date.startsWith(mk)) { monthSpend[i.cat] = (monthSpend[i.cat] || 0) + i.amt; monthTotal += i.amt; } });
    const prefs = db.settings.prefs;
    const budgetSpend = {};
    let budgetTotal = 0;
    ex.forEach((i) => {
      const included = prefs.budgetStart && prefs.budgetEnd ? i.date >= prefs.budgetStart && i.date <= prefs.budgetEnd : i.date.startsWith(mk);
      if (included) { budgetSpend[i.cat] = (budgetSpend[i.cat] || 0) + i.amt; budgetTotal += i.amt; }
    });
    const budgetLabel = prefs.budgetStart && prefs.budgetEnd ? `${prefs.budgetStart} – ${prefs.budgetEnd}` : mk;
    const byCat = {};
    m.forEach((i) => { byCat[i.cat] = (byCat[i.cat] || 0) + i.amt; });
    return { s, e, a, z, m, total, ytd, year: y, inP, inA, spA, svA, svP, remaining: inA - spA - svA, monthSpend, monthTotal, budgetSpend, budgetTotal, budgetLabel, monthKey: mk, byCat, mode };
  }, [db, period, anchor, mode]);
}
